import { render, staticRenderFns } from "./NextPageCard.vue?vue&type=template&id=724a2d79&scoped=true"
import script from "./NextPageCard.vue?vue&type=script&lang=js"
export * from "./NextPageCard.vue?vue&type=script&lang=js"
import style0 from "./NextPageCard.vue?vue&type=style&index=0&id=724a2d79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724a2d79",
  null
  
)

export default component.exports